import "./headquartersPageStyles.scss";

import Layout from "../../../layout/Layout";
import { FC, useEffect, useRef, useState } from "react";

import { Helmet } from "react-helmet-async";
import ModalGarantie from "../../car/detailedCar/component/ModalGarantie";
import AccordeonComponent from "../../../components/accordeon/AccordeonComponent";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

import Icons from "../../../assets/Icons";
import HeadquartersComponent from "./headquartersComponent";

interface DetailForm {
    form: any;
}
const HeadquartersPage: FC<{}> = () => {
    const [showGaratieModal, setShowGarantieModal] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const [detailForm, setDetailForm] = useState<DetailForm>({ form: <></> });
    const mapContainerStyle = {
        width: "98%",
        height: "180px",
    };

    const location1 = {
        lat: 4.691959880308249,
        lng: -74.07611493603319,
    };
    const center = {
        lat: location1.lat,
        lng: location1.lng,
    };

    const cardInfo = {
        side_top: true,
        flex: true,
        titleBlack: `
        En wcar, ofrecemos para ti los más acertados
        seguros de vehículos en Colombia.
        Nuestra filosofía de transparencia brutal
        garantiza que encuentres el seguro perfecto
        para tu carro, sin sorpresas y con la confianza
        que solo wcar puede ofrecer.`,
        imgUrl: "./assets/services/girl-wcar.jpg",
        directionReverse: false,
        cardColor: "#FF7300",
        // cardColor: "#1e1e1e",
        textColor: "#fff",
        cardWidth: "100%",
    };

    const cardInfo2 = {
        flex: true,
        titleBlack:
            "Te recomendamos navegar nuestra web donde encontrarás más información sobre todas las soluciones que ofrecemos en wcar.",
        imgUrl: "./assets/services/rim-modern-car.jpg",

        side_top: true,
        directionReverse: true,
        cardColor: "#FF7300",
        textColor: "#fff",
        cardWidth: "100%",
    };

    useEffect(() => {
        const scriptContent = `
       !function(a,m,o,c,r,m){a[o+c]=a[o+c]||{setMeta:function(p){this.params=(this.params||[]).concat([p])}},a[o+r]=a[o+r]||function(f){a[o+r].f=(a[o+r].f||[]).concat([f])},a[o+r]({id:"1421215",hash:"62d8146dcbec3ec6c452470d162a810c",locale:"es"}),a[o+m]=a[o+m]||function(f,k){a[o+m].f=(a[o+m].f||[]).concat([[f,k]])}}(window,0,"amo_forms_","params","load","loaded");
        `;

        const script = document.createElement("script");
        script.async = true;
        script.innerHTML = scriptContent;
        document.body.appendChild(script);

        const kommoScript = document.createElement("script");
        kommoScript.id = "amoforms_script_1421215";
        kommoScript.async = true;
        kommoScript.src = "https://forms.kommo.com/forms/assets/js/amoforms.js?1734474926";

        setTimeout(() => {
            document.getElementById("form-seguro")?.appendChild(kommoScript);
        }, 1000); // Espera 1 segundo para asegurarse de que todo el DOM esté cargado

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const sectionsSeguros = [
        {
            title: "Seguros para carros",
            description: (
                <>
                    <strong>Todo Riesgo:</strong> Cobertura para accidentes, robo, daños a terceros y desastres
                    naturales.
                    <br />
                    <strong>Beneficios adicionales:</strong> Grúa, asistencia en carretera y cobertura para accidentes
                    personales.
                </>
            ),

            image: "/assets/services/auto.webp",
        },
        {
            title: "Seguros para Motos",
            description: (
                <>
                    <strong>Todo Riesgo:</strong> Protección contra robo, daños propios y responsabilidad civil.
                    Asistencia mecánica y accidentes personales incluidos.
                </>
            ),
            image: "/assets/services/motos.webp",
        },
        {
            title: "Seguros para Bicicletas",
            description: (
                <>
                    Cobertura en caso de daños materiales, accidentes o robo parcial/total. Responsabilidad civil por
                    daños a terceros incluida.
                </>
            ),
            image: "/assets/services/bicicletas.webp",
        },
        {
            title: "Seguros para Patinetas",
            description: (
                <>
                    <strong>Responsabilidad Civil:</strong> Cobertura para accidentes que afecten a terceros. Opciones
                    para accidentes personales y robo.
                </>
            ),
            image: "/assets/services/patinetas.webp",
        },
        {
            title: "Seguros de Vivienda",
            description: (
                <>
                    Protección contra incendios, inundaciones y terremotos. Cobertura por robos y daños a vecinos, con
                    asistencia domiciliaria.
                </>
            ),
            image: "/assets/services/hogar.webp",
        },
        {
            title: "Seguros para PYMES",
            description: (
                <>
                    Multirriesgo: Cobertura de bienes empresariales y responsabilidad civil. Protección contra
                    interrupciones del negocio y pérdidas de mercancías.
                </>
            ),
            image: "/assets/services/pymes.webp",
        },
        {
            title: "Seguros de Salud",
            description: (
                <>
                    Acceso a servicios médicos premium, consultas especializadas y emergencias internacionales. Medicina
                    prepagada con amplias coberturas.
                </>
            ),
            image: "/assets/services/salud.webp",
        },
        {
            title: "Seguros para Mascotas",
            description: (
                <>
                    Cobertura veterinaria, hospitalización, y compensación por fallecimiento. Responsabilidad civil por
                    daños causados por tu mascota.
                </>
            ),
            image: "/assets/services/mascotas.webp",
        },
    ];

    return (
        <div className="insurance_page">
            {/* {openModal && (
                <div className="video_conference d-flex justify-content-center align-items-center">
                    <SegurosModal
                        setOpenModal={() => setOpenModal(false)}
                        detailForm={detailForm}
                        openModal={openModal}
                    />
                </div>
            )} */}
            <Helmet>
                <title>Nuestras Sedes - wcar </title>
                <meta
                    name="description"
                    content="Conoce todo lo que necesitas saber sobre seguros de vehículos en Colombia, en wcar más que vender te asesoramos."
                />
                <meta
                    name="keywords"
                    content="Seguros de vehículos, Qué es un seguro todo riesgo en Colombia, Necesitas seguro del automóvil, seguro de automóvil"
                />
                <link rel="canonical" href="https://wcar.co/" />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <Layout>
                <section className="section_1-insurance position-relative">
                    <div className="content position-md-absolute mt-4 mt-md-0 ">
                        <div className="container">
                            <div className="col-md-5 ms-5 pt-5">
                                <div className="d-none d-md-block side side_top side_blue_neon mb-3 " />
                                <h2 className="text-white text_bold text-center text-md-start ">
                                    <i style={{ fontWeight: 500, fontSize: 50 }}>
                                        Visita nuestras <br />
                                        Sucursales <br />
                                    </i>
                                    <i className="text_italice " style={{ fontWeight: 200 }}>
                                        Aqui y ahora
                                    </i>
                                </h2>
                            </div>

                            <br />
                            <div className="d-flex justify-content-center d-md-block ms-5">
                                {/* <Button label="COMPRA TU SEGURO" onClick={() => setShowGarantieModal(true)} /> */}
                            </div>
                        </div>
                    </div>
                </section>

                {/* <Card cardInfo={cardInfo2} setShowGarantieModal={setShowGarantieModal} setSrvCode={setSrvCode} /> */}
                <section
                    className="workshop_and_service_drop_lists   pb-3 pb-md-5 position-relative"
                    style={{ backgroundColor: "white" }}
                >
                    <div
                        className=" d-flex"
                        style={{
                            flexWrap: "wrap",
                            gap: 10,
                            justifyContent: "center",
                            maxWidth: 1250,
                            margin: "auto",
                            zIndex: 0,
                            position: "relative",
                        }}
                    ></div>
                    <div className="" style={{ backgroundColor: "#fff", paddingTop: 40 }}>
                        <img
                            src="./assets/home/car_04.svg"
                            alt="sedes"
                            title="sedes"
                            className="car_4 position-absolute d-none d-md-block "
                            style={{ right: -10 }}
                            loading="lazy"
                            decoding="async"
                        />
                        <div
                            className="drop_lists text-black container"
                            style={{
                                zIndex: 0,
                                position: "relative",
                                marginBottom: 20,
                            }}
                        >
                            <div
                                style={{ display: "flex", justifyContent: "center", paddingBottom: 10, paddingTop: 10 }}
                            >
                                <div>
                                    <div className="side side_top"></div>
                                    <h2>
                                        {" "}
                                        <i className="text_orange">
                                            Nuestras Sedes WCAR <br />
                                        </i>{" "}
                                        Tu concesionario cerca de ti con Transparencia Brutal
                                    </h2>
                                    <p
                                        className="mt-2"
                                        style={{
                                            fontSize: 16,
                                            marginTop: 20,
                                            marginBottom: 20,
                                            fontFamily: "urbanist",
                                        }}
                                    >
                                        En WCAR no solo vendemos carros usados: también vendemos tranquilidad. Por eso,
                                        tenemos varias sedes para que siempre tengas un concesionario cerca de mí donde
                                        comprar, vender o mantener tu carro con toda la confianza que te merecés. Aquí
                                        no hay cuentos: hay datos, calidad y atención brutalmente transparente. Conoce
                                        nuestras sedes y descubrí por qué somos la opción número uno en carros usados en
                                        Bogotá y Sabana.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <HeadquartersComponent
                            reverse={true}
                            title={"WCAR Punto de Venta"}
                            image={"/assets/headquaters/wcar-morato.jpg"}
                            secondTitle={"Morato"}
                            content={`¿Buscas un concesionario cerca de mí en Bogotá? Nuestro Punto de Venta Morato es la
parada obligada. Una vitrina de carros usados revisados, certificados y listos para rodar. Y
lo mejor, en una ubicación privilegiada sobre la Av. Suba, con fácil acceso desde cualquier
punto de la ciudad.`}
                            located={"Cll 98a #69B-35"}
                        />

                        <HeadquartersComponent
                            reverse={false}
                            image={"/assets/headquaters/wcar-compra-tu-usado.svg"}
                            title={"WCAR Compramos tu usado"}
                            secondTitle={"Morato"}
                            content={`Si estás pensando en vender tu carro en un concesionario cerca de ti;, llegaste al
lugar indicado. En nuestra sede de Morato, evaluamos tu carro sin carreta: diagnóstico en
menos de 30 minutos, oferta seria y plata en mano o transferencia inmediata.`}
                            located={"Cll 98a #69B-35"}
                        />
                        <HeadquartersComponent
                            reverse={true}
                            title={"WCAR VITRINA VENTAS W4"}
                            image={"/assets/headquaters/vitrina-wcar.svg"}
                            secondTitle={""}
                            content={`WCAR anuncia la apertura de su nueva sede en Morato, un espacio que ofrece una experiencia de servicio superior con la mejor eficiencia y la transparencia. Le invitamos a visitarnos para obtener una valoración técnica precisa de su vehículo en menos de 30 minutos, garantizándole una oferta seria con desembolso inmediato, Y lo mejor, asesoría de verdad y facilidades de financiación sin letras pequeñas.`}
                            located={"Calle 98A 69 55"}
                        />
                        <HeadquartersComponent
                            reverse={false}
                            title={"WCAR - Caribe compra o vende tu auto"}
                            image={"/assets/headquaters/barranquilla.png"}
                            secondTitle={""}
                            content={`¡WCAR aterriza en Barranquilla!
WCAR anuncia con orgullo la apertura de su nueva sede en Barranquilla, un espacio diseñado para revolucionar la compra y venta de vehículos en la Costa Atlántica con eficiencia, transparencia y la mejor actitud.


Te invitamos a visitarnos para vivir una experiencia de servicio superior: obtén una valoración técnica precisa de tu vehículo en menos de 30 minutos, con la garantía de una oferta seria y desembolso inmediato. En WCAR llegamos para cumplir: aquí encontrarás asesoría de verdad y facilidades de financiación claras, sin enredos ni letras pequeñas.`}
                            located={"Av. Circunvalar, Cl. 110 #43c91, Barranquilla, local A2-1"}
                        />
                        <HeadquartersComponent
                            reverse={true}
                            title={"WCAR La Felicidad Concesionario de"}
                            image={"/assets/headquaters/felicidad-wcar.svg"}
                            secondTitle={"Autos Usados"}
                            content={`En el barrio La Felicidad tenemos otro de nuestros puntos fuertes. Un concesionario cerca
de mí para quienes buscan carros usados de calidad, asesoría de verdad y facilidades de
financiación sin letras pequeñas. Llegar es fácil, por la Av. Boyacá o la Calle 13.`}
                            located={"Cl. 17 #80A-30"}
                        />

                        <HeadquartersComponent
                            reverse={false}
                            title={"WCAR Taller"}
                            image={"/assets/headquaters/taller-wcar.svg"}
                            secondTitle={"Morato"}
                            content={`Tener un taller automotriz cerca de mí de confianza es casi un milagro... por eso abrimos
nuestro Taller Morato: diagnósticos reales, mantenimientos serios y un equipo de técnicos
que no te maquilla problemas, sino que los soluciona de frente.`}
                            located={"Cr 69b #98-28"}
                        />

                        <HeadquartersComponent
                            reverse={true}
                            image={"/assets/headquaters/cajica.svg"}
                            title={"WCAR Cajicá - "}
                            secondTitle={"Chía"}
                            content={`Si vives en la Sabana y quieres un concesionario cerca de mí, nuestra sede de Cajicá -
Chía es para vos. Aquí también aplicamos nuestra receta de éxito: carros usados revisados,
atención de calidad y todo en un espacio cómodo, lejos del tráfico bogotano.`}
                            located={"Cra 5 #9-26 sur Cajicá. Torre 3 - Local 3"}
                        />

                        <HeadquartersComponent
                            reverse={false}
                            title={"WCoffee Morato: Un café con aroma a "}
                            image={"/assets/headquaters/wcar-coffe.svg"}
                            secondTitle={"transparencia"}
                            content={`Y como no todo es negocio, creamos WCoffee en Morato: un espacio brutal para que te
tomés un café premium mientras decidís tu próxima compra o esperás tu evaluación.
Porque los mejores negocios se cierran con un buen café... y mejor aún si es colombiano.`}
                            located={"Cl. 98a #69b-12"}
                        />

                        <HeadquartersComponent
                            reverse={true}
                            title={"WCAR Puente"}
                            image={"/assets/headquaters/puente-aranda.svg"}
                            secondTitle={" Aranda"}
                            content={`  ¿Andas buscando concesionario en Bogotá? ¡No busques más! Nuestro Punto de Puente Aranda es la parada obligada. Te espera una vitrina de carros usados que ya están revisados, certificados y listos para arrancar. Y lo mejor de todo: estamos en una ubicación en la Carrera 50 # 15-55, con acceso facilísimo desde cualquier zona de la ciudad.  Teléfono: +57 324 4001212`}
                            located={"Ak. 50 #15-55, Puente Aranda"}
                        />
                    </div>
                </section>
            </Layout>
            {showGaratieModal && (
                <ModalGarantie
                    id={"185"}
                    close={() => setShowGarantieModal(false)}
                    carValue={100000}
                    SrvCode={"1002"}
                />
            )}
        </div>
    );
};

export default HeadquartersPage;
